import {
  faExclamation as CreateIcon,
  faExclamation as DefaultIcon,
  faTrashCan as DeleteIcon,
  type IconDefinition,
  faPen as UpdateIcon
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAtom } from 'jotai';
import { useMemo } from 'react';

import ActivityLog from '@/components/ActivityLog';
import {
  rulesDetailsAtom,
  type SensorRuleLogDTO
} from '@/pages/Administration/AdministrationRules';
import getDateTime from '@/utils/getDateTime.utils';

const RulesFileActivityLog = () => {
  const [rulesDetails] = useAtom(rulesDetailsAtom);

  const getIcon = (action: string) => {
    const displayIcon = (icon: IconDefinition) => {
      return <FontAwesomeIcon icon={icon} size="sm" />;
    };

    // we determine what icon to get/display based on the action type
    switch (action) {
      case 'create':
        return displayIcon(CreateIcon);
      case 'delete':
        return displayIcon(DeleteIcon);
      case 'update':
        return displayIcon(UpdateIcon);
      default:
        return displayIcon(DefaultIcon);
    }
  };

  // take the original activities and insert the icon and massage the created_at date
  const ruleActivites = useMemo(() => {
    return rulesDetails?.logs?.map((rule: SensorRuleLogDTO) => {
      return {
        ...rule,
        created_at: getDateTime(rule.created_at),
        icon: getIcon(rule.action)
      };
    });
  }, [rulesDetails]);

  return <ActivityLog activities={ruleActivites || []} />;
};

export default RulesFileActivityLog;
